export default __webpack_public_path__ + "static/media/476.6a39e79d.png";